<div *ngIf="isLoaded" class="slide-config">
  <h2>{{ 'dynamicContent.slidesConfig' | translate }}</h2>

  <mat-radio-group [(ngModel)]="slideObject.slide.type" [disabled]="slideObject.file">
    <mat-radio-button value="image">Image</mat-radio-button>
    <mat-radio-button value="video">Video</mat-radio-button>
    <mat-radio-button value="website">Website</mat-radio-button>
  </mat-radio-group>

  <mat-form-field appearance="fill">
    <mat-label>{{ 'dynamicContent.screensaverDuration' | translate }}</mat-label>
    <input matInput type="number" [(ngModel)]="slideObject.slide.duration" name="duration" [disabled]="slideObject.slide.type === 'video' && slideObject.file"/>
  </mat-form-field>

  <mat-form-field appearance="fill" *ngIf="slideObject.slide.type === 'website'">
    <mat-label>{{ 'dynamicContent.screensaverUrl' | translate }}</mat-label>
    <input matInput [(ngModel)]="slideObject.slide.value" name="websiteTitle"/>
  </mat-form-field>

  <div *ngIf="slideObject.file" class="preview">
    <img *ngIf="slideObject.slide.type === 'image'" [src]="imageAssetPath + slideObject.slide.value + '/' + 'oneToOne'" alt="Slide Image" width="200"/>
    <video *ngIf="slideObject.slide.type === 'video'" controls width="200" id="slide-video">
      <source [src]="videoPath + slideObject.slide.value"/>
      {{ 'general.noHtml5VideoSupport' | translate }}
    </video>
    <button mat-icon-button (click)="slideObject.file = null; slideObject.slide.value = null">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="row asset" *ngIf="slideObject.slide.type !== 'website'">
    <button (click)="chooseFromAssets(slideObject.slide.type)" class="ibexfusion-raised-button" mat-button>
      {{ 'dynamicContent.choose' + (slideObject.slide.type === 'video' ? 'Video' : 'Image') | translate }}
    </button>
  </div>

  <div class="row">
    <button (click)="cancel()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
    <button (click)="saveSlide()" class="ibexfusion-raised-button" mat-button [disabled]="saveDisabled()" [class.disabled]="saveDisabled()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</div>
